/**
 * Constant variables
 */
const ACCOUNTS_DEACTIVATED = 'ACCOUNTS_DEACTIVATED';
const ACCOUNTS_REMOVED = 'ACCOUNTS_REMOVED';
const CUSTOMER_DEALER_EAT_LIMITS_FINAL_BY_SYSTEM_GAME_TYPE_ID = 'CUSTOMER_DEALER_EAT_LIMITS_FINAL_BY_SYSTEM_GAME_TYPE_ID';
const CUSTOMER_DEALER_EAT_LIMITS_OVERRIDE_BY_SYSTEM_GAME_TYPE_ID = 'CUSTOMER_DEALER_EAT_LIMITS_OVERRIDE_BY_SYSTEM_GAME_TYPE_ID';
const CUSTOMER_DEALER_TANK_LIMITS_FINAL_BY_SYSTEM_GAME_TYPE_ID = 'CUSTOMER_DEALER_TANK_LIMITS_FINAL_BY_SYSTEM_GAME_TYPE_ID';
const CUSTOMER_DEALER_TANK_LIMITS_OVERRIDE_BY_SYSTEM_GAME_TYPE_ID = 'CUSTOMER_DEALER_TANK_LIMITS_OVERRIDE_BY_SYSTEM_GAME_TYPE_ID';
const CUSTOMER_RELATIONSHIPS_ANCESTOR_BY_SYSTEM_GAME_ID = 'CUSTOMER_RELATIONSHIPS_ANCESTOR_BY_SYSTEM_GAME_ID';
const CUSTOMER_RELATIONSHIPS_INPUT_BY_SYSTEM_GAME_ID = 'CUSTOMER_RELATIONSHIPS_INPUT_BY_SYSTEM_GAME_ID';
const CUSTOMER_RUNNER_CONTRACTS_INPUT_BY_SYSTEM_GAME_TYPE_ID = 'CUSTOMER_RUNNER_CONTRACTS_INPUT_BY_SYSTEM_GAME_TYPE_ID';
const CUSTOMER_RUNNER_TICKET_ADDONS_ARCHIVED_BY_SYSTEM_GAME_ID = 'CUSTOMER_RUNNER_TICKET_ADDONS_ARCHIVED_BY_SYSTEM_GAME_ID';
const CUSTOMER_RUNNER_TICKET_ADDONS_INPUT_BY_SYSTEM_GAME_ID = 'CUSTOMER_RUNNER_TICKET_ADDONS_INPUT_BY_SYSTEM_GAME_ID';
const CUSTOMER_RUNNER_TICKET_HOOKS_ARCHIVED_BY_SYSTEM_GAME_ID = 'CUSTOMER_RUNNER_TICKET_HOOKS_ARCHIVED_BY_SYSTEM_GAME_ID';
const CUSTOMER_RUNNER_TICKET_HOOKS_INPUT_BY_SYSTEM_GAME_ID = 'CUSTOMER_RUNNER_TICKET_HOOKS_INPUT_BY_SYSTEM_GAME_ID';
const CUSTOMER_RUNNER_TICKET_SCHEMES_ARCHIVED_BY_SYSTEM_GAME_ID = 'CUSTOMER_RUNNER_TICKET_SCHEMES_ARCHIVED_BY_SYSTEM_GAME_ID';
const CUSTOMER_RUNNER_TICKET_SCHEMES_INPUT_BY_SYSTEM_GAME_ID = 'CUSTOMER_RUNNER_TICKET_SCHEMES_INPUT_BY_SYSTEM_GAME_ID';
const CUSTOMER_SYSTEM_GAME_TYPES_INPUT_BY_SYSTEM_GAME_ID = 'CUSTOMER_SYSTEM_GAME_TYPES_INPUT_BY_SYSTEM_GAME_ID';
const CUSTOMER_SYSTEM_TICKET_NUMBER_PLUGINS_INPUT = 'CUSTOMER_SYSTEM_TICKET_NUMBER_PLUGINS_INPUT';
const DEFAULT = 'DEFAULT';
const DRAWS_INPUT_BY_SYSTEM_GAME_ID = 'DRAWS_INPUT_BY_SYSTEM_GAME_ID';
const DRAWS_OPEN_BY_SYSTEM_GAME_ID = 'DRAWS_OPEN_BY_SYSTEM_GAME_ID';
const DRAW_CUSTOMERS_INPUT = 'DRAW_CUSTOMERS_INPUT';
const DRAW_SYSTEM_GAME_TYPES_INPUT_BY_SYSTEM_GAME_ID = 'DRAW_SYSTEM_GAME_TYPES_INPUT_BY_SYSTEM_GAME_ID';
const SYSTEM_GAME_CATEGORIES_DEACTIVATED_BY_ROOT_ID = 'SYSTEM_GAME_CATEGORIES_DEACTIVATED_BY_ROOT_ID';
const SYSTEM_GAME_CATEGORIES_INPUT_BY_ROOT_ID = 'SYSTEM_GAME_CATEGORIES_INPUT_BY_ROOT_ID';
const SYSTEM_GAME_PRIZES_INPUT_BY_ROOT_ID = 'SYSTEM_GAME_PRIZES_INPUT_BY_ROOT_ID';
const SYSTEM_GAME_TYPES_DEACTIVATED_BY_ROOT_ID = 'SYSTEM_GAME_TYPES_DEACTIVATED_BY_ROOT_ID';
const SYSTEM_GAME_TYPES_INPUT_BY_ROOT_ID = 'SYSTEM_GAME_TYPES_INPUT_BY_ROOT_ID';
const SYSTEM_TRANSLATIONS_GLOBAL = 'SYSTEM_TRANSLATIONS_GLOBAL';
const SYSTEM_TRANSLATIONS_INPUT = 'SYSTEM_TRANSLATIONS_INPUT';
module.exports = {
  ACCOUNTS_DEACTIVATED,
  ACCOUNTS_REMOVED,
  CUSTOMER_DEALER_EAT_LIMITS_FINAL_BY_SYSTEM_GAME_TYPE_ID,
  CUSTOMER_DEALER_EAT_LIMITS_OVERRIDE_BY_SYSTEM_GAME_TYPE_ID,
  CUSTOMER_DEALER_TANK_LIMITS_FINAL_BY_SYSTEM_GAME_TYPE_ID,
  CUSTOMER_DEALER_TANK_LIMITS_OVERRIDE_BY_SYSTEM_GAME_TYPE_ID,
  CUSTOMER_RELATIONSHIPS_ANCESTOR_BY_SYSTEM_GAME_ID,
  CUSTOMER_RELATIONSHIPS_INPUT_BY_SYSTEM_GAME_ID,
  CUSTOMER_RUNNER_CONTRACTS_INPUT_BY_SYSTEM_GAME_TYPE_ID,
  CUSTOMER_RUNNER_TICKET_ADDONS_ARCHIVED_BY_SYSTEM_GAME_ID,
  CUSTOMER_RUNNER_TICKET_ADDONS_INPUT_BY_SYSTEM_GAME_ID,
  CUSTOMER_RUNNER_TICKET_HOOKS_ARCHIVED_BY_SYSTEM_GAME_ID,
  CUSTOMER_RUNNER_TICKET_HOOKS_INPUT_BY_SYSTEM_GAME_ID,
  CUSTOMER_RUNNER_TICKET_SCHEMES_ARCHIVED_BY_SYSTEM_GAME_ID,
  CUSTOMER_RUNNER_TICKET_SCHEMES_INPUT_BY_SYSTEM_GAME_ID,
  CUSTOMER_SYSTEM_GAME_TYPES_INPUT_BY_SYSTEM_GAME_ID,
  CUSTOMER_SYSTEM_TICKET_NUMBER_PLUGINS_INPUT,
  DEFAULT,
  DRAWS_INPUT_BY_SYSTEM_GAME_ID,
  DRAWS_OPEN_BY_SYSTEM_GAME_ID,
  DRAW_CUSTOMERS_INPUT,
  DRAW_SYSTEM_GAME_TYPES_INPUT_BY_SYSTEM_GAME_ID,
  SYSTEM_GAME_CATEGORIES_DEACTIVATED_BY_ROOT_ID,
  SYSTEM_GAME_CATEGORIES_INPUT_BY_ROOT_ID,
  SYSTEM_GAME_PRIZES_INPUT_BY_ROOT_ID,
  SYSTEM_GAME_TYPES_DEACTIVATED_BY_ROOT_ID,
  SYSTEM_GAME_TYPES_INPUT_BY_ROOT_ID,
  SYSTEM_TRANSLATIONS_GLOBAL,
  SYSTEM_TRANSLATIONS_INPUT,
};
